var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListCashBooking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M461.124,261.039c-4.958,41.983-24.127,90.797-62.412,113.222 c-57.846,33.888-53.004,86.011-165.913,108.671c-17.604,3.535-34.31,5.022-50.063,4.728c-8.468-0.157-16.666-0.84-24.571-2.003 c-71.76-10.483-120.052-60.363-137.769-120.575c-23.315-79.189,23.24-131.032,54.097-162.268 c30.858-31.236,53.458-128.562,164.28-151.71c16.898-3.522,34.177-5.319,51.452-4.888c39.43,0.967,82.438,13.915,112.197,40.939 c2.234,2.031,4.407,4.136,6.526,6.305C450.311,135.915,467.886,203.802,461.124,261.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M461.124,261.039c-4.958,41.983-24.127,90.797-62.412,113.222 c-57.846,33.888-53.004,86.011-165.913,108.671c-17.604,3.535-34.31,5.022-50.063,4.728c-8.468-0.157-16.666-0.84-24.571-2.003 c-71.76-10.483-120.052-60.363-137.769-120.575c-23.315-79.189,23.24-131.032,54.097-162.268 c30.858-31.236,53.458-128.562,164.28-151.71c16.898-3.522,34.177-5.319,51.452-4.888c39.43,0.967,82.438,13.915,112.197,40.939 c2.234,2.031,4.407,4.136,6.526,6.305C450.311,135.915,467.886,203.802,461.124,261.039z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor_1_"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 488.599,
    y1: 444.107,
    x2: 14.201,
    y2: 444.107
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.344,329.877c3.841,1.677,13.233,1.466,13.24,1.466c0.097-0.002-2.019-6.149-2.197-6.521 c-2.06-4.312-8.578-11.43-13.881-10.713c-3.82,0.516-5.945,4.34-5.083,7.937C21.305,325.719,25.074,328.447,28.344,329.877z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.586,357.084c3.983,0.581,12.366-1.85,13.032-2.046c1.324,4.693,3.062,9.4,5.084,14.068 c1.152,2.67,2.397,5.322,3.678,7.967c-0.764-1.12-1.457-2.116-1.568-2.245c-3.127-3.614-11.293-8.758-16.217-6.666 c-3.55,1.506-4.588,5.754-2.807,8.996c1.819,3.31,6.176,4.948,9.707,5.462c3.584,0.523,10.772-1.407,12.668-1.942 c0.502,1.01,0.992,2.023,1.499,3.03c2.428,4.834,4.87,9.646,7.122,14.44c0.794,1.689,1.514,3.381,2.242,5.073 c-0.68-0.995-1.261-1.826-1.363-1.944c-3.126-3.613-11.292-8.758-16.217-6.666c-3.549,1.507-4.588,5.755-2.806,8.996 c1.821,3.311,6.176,4.948,9.708,5.462c3.42,0.499,10.071-1.222,12.326-1.848c0.692,1.754,1.389,3.51,1.98,5.24 c0.377,1.191,0.824,2.311,1.135,3.528c0.335,1.199,0.665,2.386,0.994,3.561c0.549,2.286,1.129,4.642,1.607,6.885 c0.345,1.558,0.645,3.049,0.952,4.551c-0.771-1.691-2.351-4.968-2.514-5.228c-2.542-4.046-9.834-10.367-15.02-9.046 c-3.736,0.952-5.407,4.994-4.136,8.467c1.297,3.548,5.354,5.826,8.767,6.87c3.758,1.148,12.078,0.099,13.117-0.039 c0.499,2.486,0.96,4.908,1.359,7.202c0.299,1.697,0.572,3.328,0.822,4.895h3.332c-0.315-1.745-0.658-3.569-1.038-5.478 c-0.496-2.526-1.076-5.215-1.699-7.972c0.626-0.248,4.174-1.684,7.318-3.441c2.739,2.966,9.757,6.437,10.665,6.879 c-0.955,2.349-1.907,4.624-2.84,6.756c-0.491,1.13-0.968,2.197-1.443,3.256h3.523c0.28-0.67,0.557-1.326,0.842-2.022 c0.98-2.38,1.98-4.945,2.981-7.586c1.007,0.21,9.243,1.883,13.081,1.017c3.481-0.787,7.698-2.757,9.256-6.198 c1.526-3.369,0.16-7.524-3.495-8.752c-5.072-1.704-12.815,4.057-15.652,7.902c-0.168,0.227-1.709,2.891-2.653,4.587 c0.403-1.081,0.807-2.127,1.208-3.246c0.811-2.206,1.553-4.432,2.36-6.824c0.35-1.169,0.703-2.349,1.06-3.542 c0.378-1.175,0.629-2.464,0.953-3.707c0.69-2.897,1.248-5.866,1.744-8.868c1.934,0.703,8.838,3.106,12.415,2.854 c3.561-0.25,8.025-1.558,10.087-4.724c2.019-3.099,1.298-7.414-2.128-9.181c-4.756-2.452-13.282,2.07-16.669,5.44 c-0.211,0.209-2.369,2.902-3.526,4.403c0.284-1.807,0.576-3.61,0.804-5.448c0.659-5.306,1.16-10.697,1.684-16.073 c0.159-1.647,0.338-3.286,0.511-4.927c0.686,0.258,8.829,3.29,12.836,3.009c3.56-0.249,8.026-1.558,10.087-4.724 c2.019-3.099,1.298-7.413-2.128-9.18c-4.756-2.453-13.282,2.069-16.668,5.439c-0.255,0.254-3.355,4.132-4.096,5.157 c0.382-3.615,0.796-7.214,1.349-10.745c0.755-4.873,1.766-9.612,3.084-14.132c0.319,0.121,8.805,3.324,12.907,3.036 c3.56-0.25,8.027-1.558,10.088-4.724c2.018-3.099,1.299-7.413-2.128-9.181c-4.757-2.453-13.282,2.069-16.669,5.44 c-0.265,0.265-3.599,4.438-4.149,5.238c0.079-0.268,0.132-0.556,0.214-0.822c1.469-4.807,3.495-9.279,5.598-13.372 c1.217-2.382,2.514-4.59,3.823-6.71c1.52,0.759,8.502,4.149,12.222,4.298c3.566,0.142,8.149-0.667,10.545-3.587 c2.347-2.859,2.105-7.226-1.106-9.359c-4.459-2.96-13.429,0.598-17.166,3.576c-0.203,0.162-2.086,2.037-3.438,3.422 c0.605-0.948,1.212-1.937,1.811-2.833c2.239-3.371,4.496-6.32,6.517-8.916c1.161-1.466,2.239-2.77,3.262-3.979 c1.878-0.033,9.451-0.263,12.761-1.817c3.23-1.518,6.925-4.347,7.706-8.043c0.764-3.619-1.463-7.384-5.295-7.796 c-5.32-0.574-11.643,6.718-13.587,11.083c-0.167,0.378-2.117,6.579-2.019,6.579c0,0,0.091-0.001,0.113-0.001 c-1.008,1.143-2.073,2.381-3.212,3.756c-2.082,2.557-4.409,5.464-6.729,8.8c-2.328,3.328-4.763,7.008-6.978,11.116 c-2.226,4.115-4.357,8.558-5.961,13.419c-0.018,0.055-0.03,0.115-0.048,0.17c0.028-1.568-0.041-5.953-0.085-6.289 c-0.615-4.739-4.586-13.535-9.849-14.508c-3.791-0.7-7.001,2.269-7.304,5.956c-0.308,3.765,2.421,7.533,5.084,9.911 c3.002,2.681,11.334,5.278,11.998,5.483c-1.485,4.643-2.632,9.529-3.521,14.536c-0.511,2.863-0.936,5.763-1.326,8.675 c-0.02-1.356-0.047-2.569-0.07-2.738c-0.614-4.74-4.586-13.534-9.848-14.507c-3.791-0.701-7.002,2.27-7.303,5.956 c-0.309,3.765,2.421,7.533,5.083,9.911c2.701,2.412,9.761,4.77,11.637,5.368c-0.137,1.119-0.288,2.235-0.421,3.354 c-0.642,5.37-1.259,10.732-2.026,15.973c-0.268,1.847-0.602,3.656-0.928,5.466c-0.019-1.204-0.045-2.218-0.065-2.372 c-0.615-4.74-4.586-13.535-9.847-14.508c-3.792-0.7-7.003,2.269-7.305,5.957c-0.309,3.764,2.422,7.533,5.084,9.91 c2.577,2.303,9.074,4.536,11.3,5.258c-0.39,1.845-0.778,3.693-1.24,5.464c-0.343,1.201-0.589,2.381-1,3.569 c-0.382,1.183-0.761,2.357-1.135,3.518c-0.805,2.21-1.62,4.494-2.458,6.63c-0.572,1.49-1.145,2.899-1.717,4.32 c0.289-1.835,0.78-5.44,0.787-5.746c0.073-3.174-1.054-8.334-3.298-11.962c0.014-0.469-0.013-0.936-0.087-1.4 c-0.587-3.652-4.018-6.365-7.744-5.372c-5.171,1.377-8.451,10.454-8.695,15.225c-0.015,0.282,0.17,3.353,0.318,5.29 c-0.261-1.125-0.5-2.22-0.783-3.374c-0.542-2.287-1.151-4.553-1.796-6.995c-0.353-1.168-0.71-2.346-1.071-3.538 c-0.332-1.188-0.834-2.402-1.25-3.617c-1.023-2.796-2.195-5.581-3.438-8.359c2.003-0.48,9.085-2.285,11.929-4.468 c2.832-2.172,5.835-5.728,5.808-9.504c-0.027-3.699-3.006-6.901-6.839-6.484c-5.32,0.577-9.937,9.053-10.903,13.733 c-0.06,0.292-0.375,3.728-0.512,5.618c-0.76-1.664-1.511-3.329-2.335-4.988c-2.377-4.789-4.932-9.562-7.462-14.335 c-0.775-1.462-1.53-2.927-2.292-4.391c0.715-0.164,9.18-2.128,12.366-4.572c2.831-2.172,5.835-5.727,5.808-9.505 c-0.027-3.698-3.007-6.9-6.839-6.483c-5.32,0.577-9.937,9.052-10.903,13.732c-0.072,0.353-0.519,5.297-0.571,6.56 c-1.676-3.225-3.315-6.455-4.803-9.705c-2.058-4.481-3.83-8.991-5.223-13.488c0.333-0.076,9.177-2.086,12.441-4.59 c2.832-2.173,5.835-5.727,5.807-9.505c-0.026-3.699-3.006-6.9-6.84-6.483c-5.32,0.577-9.936,9.053-10.902,13.733 c-0.076,0.368-0.553,5.688-0.571,6.657c-0.083-0.267-0.198-0.535-0.277-0.802c-1.426-4.821-2.203-9.668-2.707-14.243 c-0.299-2.657-0.435-5.214-0.512-7.704c1.686-0.206,9.38-1.23,12.564-3.158c3.054-1.849,6.429-5.052,6.817-8.809 c0.38-3.68-2.231-7.189-6.085-7.196c-5.351-0.01-10.871,7.907-12.345,12.452c-0.08,0.248-0.617,2.85-0.98,4.752 c-0.017-1.125-0.057-2.285-0.052-3.363c0.008-4.046,0.263-7.752,0.516-11.031c0.159-1.864,0.34-3.546,0.527-5.118 c1.548-1.065,7.737-5.434,9.64-8.556c1.858-3.048,3.377-7.445,1.99-10.959c-1.359-3.441-5.293-5.352-8.717-3.582 c-4.754,2.457-6.005,12.027-5.219,16.741c0.069,0.407,1.864,6.655,1.946,6.601c0,0,0.075-0.052,0.093-0.064 c-0.21,1.509-0.416,3.13-0.606,4.905c-0.326,3.28-0.663,6.99-0.758,11.052c-0.106,4.059-0.106,8.473,0.313,13.122 c0.414,4.659,1.087,9.541,2.431,14.48c0.015,0.056,0.039,0.112,0.054,0.168c-0.842-1.323-3.32-4.942-3.542-5.198 c-3.126-3.614-11.291-8.758-16.217-6.667c-3.548,1.508-4.588,5.756-2.806,8.998C23.7,354.932,28.055,356.569,31.586,357.084z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.35,331.943c0.083,0.052,1.708-6.243,1.766-6.651c0.659-4.733-0.85-14.265-5.669-16.593 c-3.471-1.677-7.352,0.34-8.616,3.817c-1.292,3.549,0.345,7.905,2.285,10.901C115.393,326.934,123.344,331.938,123.35,331.943z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M216.609,64.51c3.841,1.677,13.233,1.465,13.24,1.465c0.097-0.003-2.019-6.149-2.197-6.521 c-2.06-4.312-8.578-11.43-13.881-10.714c-3.82,0.516-5.945,4.34-5.083,7.937C209.57,60.352,213.338,63.08,216.609,64.51z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.851,91.716c3.983,0.581,12.366-1.85,13.032-2.047c1.324,4.693,3.062,9.401,5.084,14.068 c1.152,2.67,2.397,5.322,3.678,7.967c-0.764-1.12-1.457-2.116-1.568-2.245c-3.127-3.614-11.293-8.758-16.217-6.666 c-3.55,1.506-4.588,5.755-2.807,8.996c1.818,3.31,6.176,4.948,9.707,5.462c3.584,0.523,10.772-1.407,12.668-1.943 c0.502,1.01,0.992,2.023,1.499,3.03c2.427,4.834,4.87,9.646,7.122,14.44c0.794,1.689,1.514,3.381,2.242,5.073 c-0.68-0.995-1.261-1.826-1.363-1.944c-3.126-3.613-11.291-8.758-16.217-6.666c-3.549,1.507-4.588,5.755-2.806,8.997 c1.821,3.311,6.176,4.948,9.708,5.462c3.42,0.499,10.071-1.222,12.326-1.848c0.692,1.754,1.389,3.51,1.98,5.24 c0.377,1.191,0.824,2.311,1.135,3.529c0.335,1.199,0.665,2.385,0.994,3.561c0.549,2.285,1.129,4.642,1.607,6.885 c0.345,1.558,0.645,3.05,0.952,4.551c-0.771-1.691-2.351-4.968-2.514-5.227c-2.542-4.046-9.834-10.367-15.02-9.046 c-3.736,0.952-5.407,4.994-4.136,8.468c1.297,3.548,5.354,5.826,8.767,6.87c3.758,1.148,12.078,0.099,13.117-0.039 c0.499,2.486,0.96,4.908,1.359,7.202c0.299,1.697,0.572,3.328,0.822,4.895h3.332c-0.315-1.745-0.658-3.569-1.038-5.478 c-0.496-2.526-1.076-5.216-1.699-7.972c0.626-0.248,4.174-1.684,7.318-3.441c2.739,2.966,9.757,6.437,10.665,6.879 c-0.955,2.349-1.907,4.624-2.84,6.756c-0.491,1.13-0.968,2.197-1.443,3.256h3.523c0.28-0.67,0.557-1.326,0.842-2.022 c0.98-2.381,1.98-4.945,2.981-7.586c1.007,0.211,9.242,1.883,13.081,1.017c3.481-0.787,7.698-2.757,9.256-6.198 c1.526-3.369,0.16-7.524-3.496-8.752c-5.072-1.704-12.815,4.057-15.652,7.902c-0.168,0.227-1.709,2.891-2.653,4.587 c0.403-1.081,0.807-2.127,1.209-3.246c0.811-2.206,1.553-4.432,2.36-6.824c0.35-1.169,0.703-2.349,1.06-3.542 c0.378-1.175,0.629-2.464,0.953-3.707c0.69-2.897,1.248-5.865,1.744-8.868c1.934,0.703,8.838,3.106,12.415,2.854 c3.56-0.25,8.025-1.558,10.087-4.724c2.019-3.099,1.298-7.414-2.128-9.181c-4.756-2.453-13.282,2.07-16.669,5.44 c-0.211,0.209-2.37,2.902-3.526,4.403c0.284-1.808,0.576-3.61,0.804-5.448c0.659-5.306,1.16-10.697,1.684-16.073 c0.159-1.647,0.338-3.286,0.511-4.927c0.686,0.258,8.829,3.29,12.836,3.009c3.56-0.249,8.026-1.558,10.087-4.724 c2.019-3.099,1.299-7.413-2.128-9.18c-4.756-2.453-13.282,2.069-16.668,5.439c-0.255,0.254-3.355,4.132-4.096,5.157 c0.382-3.615,0.796-7.214,1.349-10.745c0.755-4.873,1.766-9.612,3.084-14.132c0.319,0.121,8.805,3.324,12.908,3.036 c3.561-0.25,8.027-1.558,10.088-4.724c2.018-3.099,1.299-7.413-2.128-9.181c-4.757-2.453-13.282,2.069-16.669,5.439 c-0.265,0.265-3.599,4.438-4.149,5.238c0.079-0.268,0.132-0.555,0.214-0.822c1.469-4.807,3.495-9.279,5.598-13.372 c1.217-2.382,2.514-4.59,3.823-6.71c1.52,0.759,8.501,4.149,12.222,4.298c3.566,0.142,8.149-0.667,10.545-3.587 c2.347-2.859,2.105-7.226-1.106-9.359c-4.459-2.96-13.429,0.598-17.166,3.576c-0.203,0.162-2.086,2.037-3.438,3.422 c0.605-0.948,1.212-1.937,1.811-2.833c2.238-3.371,4.496-6.32,6.517-8.916c1.161-1.466,2.239-2.77,3.262-3.979 c1.878-0.033,9.451-0.263,12.761-1.817c3.23-1.518,6.925-4.347,7.706-8.043c0.764-3.619-1.462-7.384-5.295-7.796 c-5.32-0.574-11.643,6.718-13.587,11.083c-0.168,0.378-2.117,6.579-2.019,6.578c0,0,0.091-0.001,0.113-0.001 c-1.008,1.143-2.073,2.381-3.211,3.757c-2.082,2.557-4.409,5.464-6.729,8.8c-2.328,3.328-4.763,7.008-6.978,11.116 c-2.226,4.115-4.357,8.558-5.961,13.419c-0.018,0.055-0.03,0.115-0.048,0.17c0.028-1.568-0.041-5.954-0.085-6.289 c-0.614-4.739-4.586-13.535-9.849-14.508c-3.79-0.7-7.001,2.27-7.303,5.957c-0.308,3.765,2.421,7.533,5.084,9.911 c3.002,2.681,11.334,5.278,11.998,5.483c-1.486,4.643-2.632,9.529-3.52,14.536c-0.511,2.864-0.936,5.763-1.326,8.675 c-0.02-1.356-0.047-2.569-0.07-2.738c-0.615-4.74-4.586-13.534-9.849-14.507c-3.791-0.701-7.002,2.27-7.303,5.956 c-0.309,3.765,2.421,7.533,5.083,9.911c2.701,2.412,9.76,4.77,11.637,5.368c-0.137,1.119-0.288,2.235-0.421,3.354 c-0.642,5.37-1.259,10.732-2.026,15.973c-0.268,1.847-0.602,3.656-0.928,5.466c-0.019-1.204-0.045-2.218-0.065-2.372 c-0.615-4.74-4.586-13.535-9.847-14.508c-3.792-0.7-7.003,2.269-7.305,5.957c-0.309,3.764,2.422,7.533,5.084,9.91 c2.577,2.302,9.074,4.536,11.3,5.258c-0.39,1.845-0.778,3.693-1.24,5.464c-0.343,1.201-0.589,2.381-1,3.569 c-0.382,1.183-0.761,2.357-1.135,3.518c-0.805,2.21-1.62,4.495-2.458,6.63c-0.572,1.49-1.145,2.9-1.717,4.32 c0.289-1.835,0.78-5.44,0.787-5.746c0.073-3.174-1.054-8.334-3.298-11.962c0.014-0.469-0.013-0.936-0.087-1.4 c-0.587-3.652-4.018-6.365-7.744-5.372c-5.171,1.377-8.451,10.454-8.695,15.225c-0.015,0.282,0.17,3.354,0.318,5.29 c-0.261-1.125-0.5-2.22-0.783-3.374c-0.542-2.287-1.151-4.553-1.796-6.995c-0.353-1.168-0.71-2.346-1.071-3.538 c-0.332-1.188-0.834-2.402-1.25-3.617c-1.023-2.796-2.195-5.581-3.438-8.359c2.003-0.48,9.085-2.285,11.929-4.468 c2.832-2.172,5.835-5.728,5.808-9.504c-0.027-3.699-3.006-6.901-6.839-6.484c-5.32,0.577-9.937,9.053-10.903,13.733 c-0.06,0.292-0.375,3.728-0.512,5.618c-0.76-1.664-1.511-3.329-2.335-4.988c-2.377-4.789-4.932-9.562-7.462-14.335 c-0.775-1.462-1.53-2.927-2.292-4.391c0.715-0.164,9.18-2.128,12.366-4.572c2.831-2.172,5.835-5.727,5.808-9.505 c-0.027-3.698-3.007-6.9-6.839-6.483c-5.32,0.577-9.937,9.052-10.903,13.732c-0.072,0.353-0.519,5.297-0.571,6.56 c-1.675-3.225-3.315-6.455-4.803-9.705c-2.058-4.481-3.83-8.992-5.223-13.488c0.333-0.076,9.177-2.086,12.441-4.59 c2.832-2.172,5.835-5.727,5.807-9.505c-0.026-3.699-3.006-6.899-6.84-6.483c-5.32,0.577-9.936,9.053-10.902,13.733 c-0.076,0.368-0.553,5.688-0.571,6.657c-0.083-0.267-0.198-0.535-0.277-0.802c-1.426-4.821-2.203-9.668-2.707-14.243 c-0.299-2.657-0.435-5.214-0.512-7.704c1.686-0.206,9.379-1.23,12.564-3.158c3.054-1.849,6.429-5.052,6.817-8.809 c0.38-3.68-2.231-7.189-6.086-7.196c-5.351-0.01-10.871,7.907-12.345,12.452c-0.08,0.248-0.617,2.85-0.98,4.752 c-0.017-1.125-0.057-2.285-0.052-3.363c0.008-4.046,0.263-7.752,0.516-11.031c0.159-1.864,0.34-3.546,0.527-5.118 c1.548-1.065,7.737-5.434,9.64-8.556c1.858-3.047,3.377-7.445,1.99-10.959c-1.358-3.441-5.293-5.352-8.717-3.582 c-4.754,2.457-6.005,12.027-5.219,16.741c0.069,0.407,1.864,6.655,1.946,6.601c0,0,0.076-0.052,0.093-0.064 c-0.21,1.509-0.416,3.13-0.606,4.905c-0.326,3.281-0.663,6.99-0.758,11.052c-0.106,4.059-0.107,8.473,0.313,13.122 c0.414,4.659,1.086,9.541,2.431,14.48c0.015,0.056,0.039,0.112,0.054,0.168c-0.842-1.323-3.32-4.942-3.542-5.198 c-3.126-3.614-11.291-8.758-16.217-6.667c-3.548,1.508-4.588,5.756-2.806,8.997C211.965,89.565,216.32,91.201,219.851,91.716z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M311.615,66.576c0.083,0.052,1.708-6.243,1.766-6.651c0.658-4.733-0.85-14.265-5.669-16.593 c-3.471-1.677-7.352,0.34-8.616,3.817c-1.292,3.549,0.345,7.905,2.285,10.901C303.658,61.567,311.609,66.571,311.615,66.576z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Report"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M251.248,339.159H63.771c-6.51,0-11.788-5.278-11.788-11.788V76.7 c0-6.51,5.278-11.788,11.788-11.788h187.477c6.51,0,11.788,5.278,11.788,11.788v250.67 C263.036,333.881,257.758,339.159,251.248,339.159z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62.081,
    y: 81.126,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 190.857,
    height: 245.017
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 118.753,
    y1: 117.822,
    x2: 196.266,
    y2: 117.822
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 83.106,
    cy: 157.743,
    r: 12.828
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 101.814,
    y1: 158.812,
    x2: 232.771,
    y2: 158.812
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 77.761,154.536 82.571,162.019 98.072,141.707  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9732 -0.2298 0.2298 0.9732 -41.2645 24.1573)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 83.106,
    cy: 189.279,
    rx: 12.828,
    ry: 12.828
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 101.814,
    y1: 190.348,
    x2: 232.771,
    y2: 190.348
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 77.761,186.072 82.571,193.556 98.072,173.244  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9732 -0.2298 0.2298 0.9732 -48.5101 25.0009)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 83.106,
    cy: 220.816,
    rx: 12.828,
    ry: 12.828
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 101.814,
    y1: 221.885,
    x2: 232.771,
    y2: 221.885
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 77.761,217.609 82.571,225.092 98.072,204.781  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -154.0992 132.677)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 83.106,
    cy: 252.353,
    rx: 12.828,
    ry: 12.828
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 101.814,
    y1: 253.422,
    x2: 232.771,
    y2: 253.422
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 77.761,249.146 82.571,256.629 98.072,236.317  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 83.106,
    cy: 283.889,
    r: 12.828
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 101.814,
    y1: 284.958,
    x2: 232.771,
    y2: 284.958
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 77.761,280.682 82.571,288.165 98.072,267.854  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M182.646,59.375 c-4.144,0-6.42-4.549-4.217-8.059c2.265-3.609,3.287-8.075,2.465-12.809c-1.234-7.103-6.838-12.957-13.895-14.432 c-11.691-2.444-21.984,6.411-21.984,17.672c0,3.638,1.077,7.022,2.928,9.853c2.185,3.342-0.402,7.775-4.395,7.775h-31.439 l8.498,24.408h84.978l8.498-24.408H182.646z M163.095,48.978c-3.495,0-6.328-2.833-6.328-6.328c0-3.495,2.833-6.328,6.328-6.328 c3.495,0,6.328,2.833,6.328,6.328C169.424,46.145,166.59,48.978,163.095,48.978z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Boxes"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 265.266,
    y: 345.226,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 640.971 789.333)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 110.439,
    height: 98.881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.266,
    y: 345.226,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 566.0972 789.333)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 35.565,
    height: 98.881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.276,
    y: 345.226,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 566.0972 717.4195)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.544,
    height: 26.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.778,
    y: 355.55,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 722.005 721.1823)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 16.449,
    height: 10.082
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 187.312,
    y: 345.226,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 485.0633 789.333)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 110.438,
    height: 98.881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.312,
    y: 345.226,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 410.1895 789.333)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 35.565,
    height: 98.881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.323,
    y: 345.226,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 410.1895 717.4195)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.544,
    height: 26.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.982,
    y: 355.55,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 564.4121 721.1823)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 16.449,
    height: 10.082
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 108.164,
    y: 345.226,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 326.7666 789.333)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 110.439,
    height: 98.881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.164,
    y: 345.226,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 251.8928 789.333)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 35.565,
    height: 98.881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.174,
    y: 345.226,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 251.8928 717.4195)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.544,
    height: 26.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.512,
    y: 355.55,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 409.4723 721.1823)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 16.449,
    height: 10.082
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 227.438,
    y: 246.223,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 565.315 591.3276)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 110.439,
    height: 98.881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.438,
    y: 246.223,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 490.4412 591.3276)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 35.565,
    height: 98.881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.448,
    y: 246.223,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 490.4411 519.4141)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.544,
    height: 26.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.533,
    y: 247.305,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 656.2087 551.3853)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.143,
    height: 56.776
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 199.275,
    y: 147.167,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 508.9886 393.214)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 110.439,
    height: 98.881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.275,
    y: 147.167,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 434.1148 393.214)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 35.565,
    height: 98.881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.285,
    y: 147.167,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 434.1147 321.3005)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.544,
    height: 26.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.349,
    y: 148.188,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 597.8409 353.1509)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.143,
    height: 56.776
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 146.833,
    y: 246.223,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 404.1049 591.3276)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 110.438,
    height: 98.881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.833,
    y: 246.223,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 329.2311 591.3276)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 35.565,
    height: 98.881
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.843,
    y: 246.223,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 329.2311 519.4141)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 9.544,
    height: 26.968
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.757,
    y: 247.305,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 490.6565 551.3853)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 11.143,
    height: 56.776
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M364.944,221.828 c0.151-0.587,0.794-0.897,1.347-0.65l6.377,2.845l-6.83-6.454c-0.378-0.358-0.437-0.939-0.137-1.365 c0.32-0.455,0.941-0.581,1.413-0.286l7.438,4.648l-4.316-5.29c-0.402-0.493-0.245-1.232,0.323-1.519 c0.357-0.18,0.788-0.13,1.093,0.129l8.574,7.256l-0.806-3.165c-0.18-0.708,0.295-1.416,1.019-1.517 c0.559-0.078,1.097,0.232,1.306,0.756c0.552,1.383,1.598,3.982,2.008,4.836c0.567,1.185,1.353,3.855,1.282,4.829 c-0.071,0.975-0.074,3.261-0.074,3.261l16.075,12.616l1.245-1.471l4.335,4.118l-0.124,1.61l3.942,3.011 c0,0,26.478-13.442,29.925-13.681c3.447-0.24,8.233,5.824,6.16,11.88c-2.073,6.056-37.088,15.611-38.237,15.691 c-1.149,0.08-26.412-29.425-26.412-29.425s-4.292-1.618-6.171-2.735c-1.573-0.935-7.952-3.478-9.987-4.281 c-0.355-0.14-0.534-0.531-0.414-0.893c0.117-0.356,0.487-0.563,0.851-0.476l5.296,1.258l-6.133-4.502 C364.99,222.625,364.844,222.216,364.944,221.828z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M456.326,355.007c0,0-0.867,7.369,0.217,10.403s8.019,23.846,9.103,42.268c1.084,18.422,2.167,35.344,1.517,36.211 c-0.65,0.867-4.551,0.434-4.551,0.434h-13.004c0,0-1.084-0.867-0.434-1.951c0.65-1.084,6.935-5.852,7.802-7.369 c0.867-1.517,1.951-3.684,1.951-4.335s-1.517-16.488-6.719-26.891c-5.202-10.403-11.92-35.983-12.571-45.302L456.326,355.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M449.173,442.372c0.37-0.617,2.567-2.429,4.551-4.155v2.205h13.62c0.039,2.011-0.011,3.238-0.183,3.468 c-0.65,0.867-4.551,0.434-4.551,0.434h-13.004C449.607,444.323,448.523,443.456,449.173,442.372z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M442.455,356.091c0,0-3.034,21.678-0.867,28.18c2.167,6.502,1.3,18.206-1.734,30.559c-3.034,12.354-5.418,20.156-5.418,20.806 c0,0.65,0,6.502-0.65,7.586c-0.65,1.084-19.723,0.867-21.023,0.867s-2.601-1.3-1.517-2.601c1.084-1.3,6.944-2.72,10.837-4.551 c3.684-1.734,3.901-2.167,3.901-2.167s2.167-25.358,1.3-36.628c-0.867-11.27-5.65-34.68-4.783-42.482L442.455,356.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M412.762,444.089c-1.3,0-2.601-1.3-1.517-2.601c0.873-1.047,4.841-2.172,8.387-3.526l0.716,1.575l14.038-1.053 c-0.067,1.889-0.225,4.11-0.601,4.737C433.135,444.306,414.063,444.089,412.762,444.089z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M454.559,282.571c0,0,7.402,16.085,8.052,25.838c0.65,9.753-3.468,20.373-3.468,20.373l2.601,27.959c0,0-8.669,5.418-23.19,5.202 c-14.521-0.217-21.673-2.601-21.673-2.601s-1.734-34.027,2.818-50.499s2.934-25.457,2.934-25.457 S442.822,284.258,454.559,282.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M427.029,220.345c0,0,2.118,7.004,2.932,10.914c0.815,3.91-1.303,11.403-4.072,16.615c-2.769,5.213-5.864,10.751-4.398,15.475 c1.466,4.724,2.118,6.516,2.118,6.516s-1.14,11.566-0.977,13.52c0.163,1.955,8.471,3.909,16.778,3.095 c8.308-0.815,14.498-2.443,15.149-3.91c0.652-1.466,0-9.611,1.14-13.846c1.14-4.235,1.466-23.946-1.14-28.181 c-2.606-4.235-8.633-10.914-8.633-10.914l-4.887-12.869L427.029,220.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M448.38,232.449 c-1.965-0.418-5.473-0.798-9.134,0.602c-3.189,1.22-7.29,4.379-10.201,6.844c0.928-3.31,1.359-6.506,0.916-8.636 c-0.814-3.91-2.932-10.914-2.932-10.914l14.009-3.584l4.887,12.869C445.925,229.63,446.974,230.794,448.38,232.449z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M420.567,193.694c0,0-1.953,5.218-2.649,7.444c-0.696,2.226-1.716,4.422-3.044,4.627c-1.327,0.205-2.568,1.236-1.744,2.947 c0.824,1.712,3.092,3.72,3.092,3.72s1.184,8.452,2.068,9.515c0.883,1.063,4.984,0.95,7.491,0.363 c2.508-0.587,7.331-1.451,7.331-1.451s1.57-17.032,0.586-20.558c-0.984-3.526-5.254-8.664-6.507-9.27 C425.94,190.427,420.567,193.694,420.567,193.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M419.595,204.238c-0.083,0.896,0.177,1.652,0.58,1.689c0.403,0.037,0.797-0.659,0.879-1.555 c0.083-0.896-0.177-1.652-0.58-1.689C420.072,202.646,419.678,203.342,419.595,204.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M423.728,202.001 c0,0-2.356-2.835-4.083-1.849"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M422.431,212.515 c0,0-1.934,1.458-4.22,1.411"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M426.349,193.082c0,0,4.428,8.751,4.825,9.769c0.397,1.018,0.699,19.04-0.339,23.198c-1.038,4.158-3.488,5.895-3.488,5.895 s7.519,1.838,17.356,1.6s14.309-2.607,14.309-2.607s-1.666-12.095-1.887-23.894c-0.221-11.798-5.49-20.3-12.051-21.886 c-6.561-1.586-14.541-0.195-14.541-0.195s-4.595-5.167-10.351-1.281c-5.757,3.886-3.655,9.478-1.032,11.192 c2.623,1.714,6.264,3.031,6.264,3.031L426.349,193.082z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M409.89,252.94 c0,0,25.447-15.653,28.868-16.142c3.421-0.489,8.633,5.213,7.004,11.403c-1.629,6.19-35.872,18.585-37.012,18.748 c-1.14,0.163-28.893-26.856-28.893-26.856s-4.398-1.303-6.353-2.281c-1.637-0.818-8.183-2.893-10.271-3.546 c-0.364-0.114-0.571-0.49-0.478-0.861l0,0c0.091-0.363,0.445-0.597,0.815-0.537l5.373,0.871l-6.443-4.046 c-0.339-0.213-0.514-0.611-0.443-1.005l0,0c0.108-0.596,0.727-0.952,1.297-0.746l6.567,2.375l-7.279-5.942 c-0.403-0.329-0.504-0.905-0.236-1.351l0,0c0.286-0.477,0.896-0.648,1.388-0.388l7.756,4.097l-4.687-4.963 c-0.437-0.463-0.334-1.211,0.212-1.539l0,0c0.343-0.206,0.776-0.186,1.1,0.049l9.077,6.616l-1.033-3.099 c-0.231-0.693,0.192-1.434,0.906-1.587l0,0c0.552-0.118,1.111,0.151,1.358,0.659c0.651,1.34,1.883,3.856,2.353,4.678 c0.652,1.14,1.629,3.747,1.629,4.724c0,0.977,0.163,3.258,0.163,3.258L409.89,252.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M395.46,255.042l0.321-0.535l5.114-7.054l8.996,5.486c0,0,25.447-15.653,28.868-16.142c3.421-0.489,8.633,5.213,7.005,11.403 c-1.629,6.19-35.872,18.585-37.012,18.748C408.205,267.027,404.083,262.913,395.46,255.042z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 404.017,249.306 396.864,257.975 392.746,254.725 399.899,245.838  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListCashBooking);
export default __webpack_public_path__ + "static/media/list_cash_booking.f047ac6d.svg";
export { ForwardRef as ReactComponent };